import { render, staticRenderFns } from "./CabinetPageHeader.vue?vue&type=template&id=231219ea&scoped=true"
import script from "./CabinetPageHeader.vue?vue&type=script&lang=js"
export * from "./CabinetPageHeader.vue?vue&type=script&lang=js"
import style0 from "./CabinetPageHeader.vue?vue&type=style&index=0&id=231219ea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231219ea",
  null
  
)

export default component.exports